require('./contractPreGrantedCreditView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @actions
const ContractPreGrantedCreditActions = require('../../actions/contractPreGrantedCredit');
const preContractualMailActions = require('actions/preContractualMailInfo');
const blockedAccountsActions = require('actions/blockedAccounts');
const profile = require('actions/profile');
const actionsAccount = require('actions/accounts');
// @core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @components
const ContractPreGrantedCredit = require('../../components/contracts/contractPreGrantedCredit/contractPreGrantedCredit');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');
// @common
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @utilities
const {
    PROC_HIRE_PRE_GRANTED_CREDIT,
    PROC_START,
    recordProcess
} = require('utilities/tagging');
//@constans
const {
    OVERDRAFT_LOAN_WAFFER,
    PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL,
} = require('constants/flagBasedFeatures');

class ContractPreGrantedCreditView extends React.Component {

    constructor(props) {
        super(props);

        this.setSelectedAccount = this.setSelectedAccount.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.formalize = this.formalize.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, getContractDraftDocument, validateBlockedAccount } = this.props;

        validateBlockedAccount();

        if(!immFlagBasedFeatures.get(OVERDRAFT_LOAN_WAFFER)){
            window.location.href = "/myprofile/loans-mortgages/";
        }
        this.props.getPrecontractual();
        recordProcess(PROC_HIRE_PRE_GRANTED_CREDIT, PROC_START);
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;
        this.props.resetState();
        resetBlockedAccounts();
    }

    setSelectedAccount(selectedAccount) {
        this.props.setSelectedAccount({ selectedAccount });
    }

    setVisibleStep(visibleStep) {
        this.props.setVisibleStep({ visibleStep });
    }

    validateStep(currentStep) {
        const { immFlagBasedFeatures } = this.props;
        if (__CONTACT_CENTER__ && immFlagBasedFeatures.get(PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL)) {
            this.props.validateStep({ currentStep, noMail: false });
        } else {
            this.props.validateStep({ currentStep, noMail: true });
        }
    }

    formalize() {
        const { formalize, immAccounts } = this.props;

        formalize(immAccounts);
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('contractsView-preGrantedCreditBreadcrumb')
            }
        ];
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();
        const titleHeader = getFinalTitle('contractsView-preGrantedCreditTitle');

        return (
            <OKCover
                size="medium"
                section="pg"
                customClass=""
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={titleHeader}
                />
            </OKCover>
        );
    }

    render() {
        const {
            immAccounts,
            immFlagBasedFeatures,
            immPreGrantedCredit,
            immProfile,
            getContractInformation,
            getHiringDocuments,
            getBlockedAccounts,
            onAgreeCheckbox,
            onAgreeReset,
            onDownload,
            onPrint,
            preContractualMail,
            resetBlockedAccounts,
            requestProfile,
            resetPrecontractualMail,
            sendLoansBarePrecontractualEmail,
            sendOverDraftSimpleEmail,
            sendPreContractualMail,
            setLoanAmount,
            updateConfirmationCheckbox,
            getINEDocument,
            getContractDraftDocument,
            getOverdraftInitOne,
            getOverdraftInitTwo,
            setInitApiFlag,
            officePrintReset,
            resetMailSent,
            hiringProductBanners,
            checkRadioButtonOfficeStepThree,
            checkRadioButtonOfficeStepFour,
        } = this.props;
        const header = this.buildHeader();
     
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');

        return (
            <section className="contract-pre-granted-credit-view">
                {header}
                <div className="contract-pre-granted-credit-view__content">
                    <div className="container-fluid">
                        {
                            isAccountBlockedValidationFetching ?
                                <div className="contract-pre-granted-credit-view__loading"><LoadingSection /></div>
                            :
                                isAccountBlockedValidationError ?
                                    <LoansError />
                                :
                                    <ContractPreGrantedCredit
                                        getOverdraftInitOne={getOverdraftInitOne}
                                        getOverdraftInitTwo={getOverdraftInitTwo}
                                        formalize={this.formalize}
                                        immAccounts={immAccounts}
                                        immFlagBasedFeatures={immFlagBasedFeatures}
                                        immPreGrantedCredit={immPreGrantedCredit}
                                        immProfile={immProfile}
                                        getContractInformation={getContractInformation}
                                        getHiringDocuments={getHiringDocuments}
                                        getBlockedAccounts={getBlockedAccounts}
                                        onAgreeCheckbox={onAgreeCheckbox}
                                        onAgreeReset={onAgreeReset}
                                        onDownload={onDownload}
                                        onPrint={onPrint}
                                        preContractualMail={preContractualMail}
                                        resetBlockedAccounts={resetBlockedAccounts}
                                        requestProfile={requestProfile}
                                        resetPrecontractualMail={resetPrecontractualMail}
                                        sendLoansBarePrecontractualEmail={sendLoansBarePrecontractualEmail}
                                        sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
                                        sendPreContractualMail={sendPreContractualMail}
                                        setLoanAmount={setLoanAmount}
                                        setSelectedAccount={this.setSelectedAccount}
                                        setVisibleStep={this.setVisibleStep}
                                        updateConfirmationCheckbox={updateConfirmationCheckbox}
                                        validateStep={this.validateStep}
                                        getINEDocument={getINEDocument}
                                        getContractDraftDocument={getContractDraftDocument}
                                        setInitApiFlag={setInitApiFlag}
                                        officePrintReset={officePrintReset}
                                        resetMailSent={resetMailSent}
                                        checkRadioButtonOfficeStepThree={checkRadioButtonOfficeStepThree}
                                        checkRadioButtonOfficeStepFour={checkRadioButtonOfficeStepFour}
                                    />
                        }
                    </div>
                </div>
            </section>
        );
    }
}

ContractPreGrantedCreditView.propTypes = {
    formalize: PropTypes.func.isRequired,
    hiringProductBanners: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
    getPrecontractual: PropTypes.func.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    sendLoansBarePrecontractualEmail: PropTypes.func.isRequired,
    sendOverDraftSimpleEmail:PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getINEDocument:PropTypes.func.isRequired,
    getOverdraftInitOne: PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func.isRequired,
    officePrintReset: PropTypes.func.isRequired,
    resetMailSent: PropTypes.func,
    checkRadioButtonOfficeStepFour: PropTypes.func,
    checkRadioButtonOfficeStepThree: PropTypes.func,
};

module.exports =  connect(state => ({
    hiringProductBanners: state.hiringProductBanners,
    immAccounts: state.accounts,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immPreGrantedCredit: state.contractPreGrantedCredit,
    immProfile: state.profile,
    preContractualMail: state.preContractualMail,
}), {
    formalize: ContractPreGrantedCreditActions.formalize,
    getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    getOverdraftInitOne: ContractPreGrantedCreditActions.getOverdraftInitOne,
    getOverdraftInitTwo: ContractPreGrantedCreditActions.getOverdraftInitTwo,
    getContractInformation: ContractPreGrantedCreditActions.getContractInformation,
    getHiringDocuments: ContractPreGrantedCreditActions.getHiringDocuments,
    getContractDraftDocument: ContractPreGrantedCreditActions.getContractDraftDocument,
    getPrecontractual: ContractPreGrantedCreditActions.getPrecontractual,
    onAgreeCheckbox: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditAgreeToggle,
    onAgreeReset: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditAgreeReset,
    onDownload: ContractPreGrantedCreditActions.onDownloadDocument,
    onPrint: ContractPreGrantedCreditActions.onPrintDocument,
    requestProfile: profile.requestProfile,
    resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetState: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditResetState,
    sendLoansBarePrecontractualEmail: ContractPreGrantedCreditActions.sendLoansBarePrecontractualEmail,
    sendOverDraftSimpleEmail:ContractPreGrantedCreditActions.sendOverDraftSimpleEmail,
    sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
    setLoanAmount: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditSetLoanAmount,
    setSelectedAccount: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditSetSeletedAccount,
    setVisibleStep: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditSetVisibleStep,
    updateConfirmationCheckbox: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditUpdateConfirmationCheckbox,
    validateBlockedAccount: actionsAccount.validateBlockedAccount,
    validateStep: ContractPreGrantedCreditActions.simpleActions.contractPreGrantedCreditValidateStep,
    getINEDocument: ContractPreGrantedCreditActions.getINEDocument,
    setInitApiFlag: ContractPreGrantedCreditActions.setInitApiFlag,
    officePrintReset: ContractPreGrantedCreditActions.officePrintReset,
    resetMailSent: ContractPreGrantedCreditActions.resetMailSent,
    checkRadioButtonOfficeStepThree: ContractPreGrantedCreditActions.checkRadioButtonOfficeStepThree,
    checkRadioButtonOfficeStepFour: ContractPreGrantedCreditActions.checkRadioButtonOfficeStepFour,
})(ContractPreGrantedCreditView);

